import React, { useEffect } from 'react';
import { Tooltip } from 'react-tooltip';

import { useEditor } from '@toasttab/sites-components';

import { useCart } from 'src/public/components/online_ordering/CartContext';
import { useFulfillment } from 'src/public/components/online_ordering/FulfillmentContext';
import { ScreenWidth, useIsMobile } from 'src/shared/js/utils/WindowContext';


export type FulfillmentBehaviorTooltipProps = {
  canOrderDelivery: boolean;
  canOrderTakeout: boolean;
}

export const FulfillmentBehaviorTooltip = ({ canOrderDelivery, canOrderTakeout } : FulfillmentBehaviorTooltipProps) => {
  const { isEditor } = useEditor();
  const { fulfillmentTooltipIsOpen, openFulfillmentTooltip, closeFulfillmentTooltip } = useFulfillment();
  const { loadingCart, cart } = useCart();
  const isMobile = useIsMobile(ScreenWidth.EXTRA_SMALL);
  useEffect(() => {
    if(canOrderDelivery && canOrderTakeout && !isEditor && !loadingCart && (cart?.order?.selections?.length || 0) === 0) {
      openFulfillmentTooltip();
    }
  }, [canOrderDelivery, canOrderTakeout, isEditor, openFulfillmentTooltip, loadingCart, cart?.order?.selections?.length]);

  if(isEditor || isMobile) {
    return null;
  }

  return (
    <Tooltip
      clickable
      data-testid="fulfillmentTooltip"
      isOpen={fulfillmentTooltipIsOpen}
      anchorSelect="#fulfillmentBehavior">
      <div
        onClick={e => {
          closeFulfillmentTooltip();
          e.stopPropagation();
        }} className="fulfillmentTooltip"
        tabIndex={0}>
        Pickup and delivery available!
        <TooltipCloseIcon />
      </div>
    </Tooltip>
  );
};

export const TooltipCloseIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="button">
      <path d="M4.10059 4.1001L11.9006 11.9001M11.9006 4.1001L4.10059 11.9001" stroke="white" strokeWidth="0.9" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
